import {
  ComponentIds,
  Entity,
  GuestConnectionsComponent,
  HierarchyUtils,
  InSceneComponent
} from '@inter-ikea-core/core';
import { SystemBase } from '@inter-ikea-core/core-toolbox';
import { CoreApi } from '../CoreApi';
import AdjustableHostComponent from '../components/AdjustableHostComponent';
import AdjustableComponent from '../components/AdjustableComponent';
import { CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY } from '../types';
import { getFrameToTheLeft } from './FrameDragAdaptAdjustableClothRailSystem';

/**
 * Systems that remove cloth rails connected to the deleted frames left side.
 */
export default class RemoveClothRailWhenRemovingFrameSystem extends SystemBase<InSceneComponent> {
  doingChangesOnComponent: number[] = [];
  systemsBeforeMe: string[] | null = null;
  systemsAfterMe: string[] | null = null;
  id: string = 'RemoveClothRailWhenRemovingFrameSystem';
  coreApi: CoreApi;

  constructor(coreApi: CoreApi) {
    super(ComponentIds.IN_SCENE_COMPONENT_ID);
    this.coreApi = coreApi;
  }

  protected onAddComponent(_entity: Entity, _newComponent: InSceneComponent) {
    super.onAddComponent(_entity, _newComponent);
  }

  protected onRemoveComponent(_entity: Entity, _oldComponent: InSceneComponent): void {
    super.onRemoveComponent(_entity, _oldComponent);
    if (_entity.hasComponent(AdjustableHostComponent.id)) {
      const getFrameToTheLeftResult = getFrameToTheLeft(this.coreApi, _entity);

      if (getFrameToTheLeftResult) {
        const clothRailsInFrame = HierarchyUtils.children(
          getFrameToTheLeftResult.frameToTheLeft
        ).filter(child => {
          return child.hasComponent(AdjustableComponent.id);
        });

        clothRailsInFrame.forEach(clothRail => {
          if (
            clothRail
              .getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
              ?.connections.some(c =>
                c.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY)
              )
          ) {
            this.coreApi.entities.delete(clothRail);
          }
        });
      }
    }
  }
}
